import React from 'react';
import { SectionHeading } from './SectionHeading';
import { ScrollTable } from './ScrollTable';
import { costRows } from '../data/content';
export function CostSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="costo-title" data-id="element-32" data-mp="4ky8edfn4ue9">
      <div className="mx-auto max-w-4xl" data-id="element-33" data-mp="3vsariy033hwt">
        <SectionHeading eyebrow="⚖️" title="¿Cuánto cuesta no tenerlo?" data-id="element-34" data-mp="3vr94rw9ph6z9" />

        <div className="mt-10" data-id="element-35" data-mp="3qt7kx94gh3mq">
          <ScrollTable data-id="element-36" data-mp="3qqbmljop4cxr">
            <table className="w-full min-w-[560px] border-collapse text-left" data-id="element-37" data-mp="3mr2tmh1hcj39">
              <caption className="sr-only" data-id="element-38" data-mp="3mt779qp6kwgq">
                Costo real de entrenar sin el Megakit
              </caption>
              <thead data-id="element-39" data-mp="3cswsw2retizz">
                <tr className="bg-ink" data-id="element-40" data-mp="3ctooveox5iqs">
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-neutral-300" data-id="element-41" data-mp="3curfdlibxj66">
                    Sin Megakit
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-ember" data-id="element-42" data-mp="p7tkg9lzkkro">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-43" data-mp="fbqh50feeg35">
                {costRows.map(row => <tr key={row.without} className="border-t border-line" data-id="element-44" data-mp="k99ve0c3isv3">
                    <th scope="row" className="px-5 py-4 text-sm font-semibold text-white" data-id="element-45" data-mp="17xt1c97oatk0">
                      {row.without}
                    </th>
                    <td className="px-5 py-4 text-sm text-neutral-400" data-id="element-46" data-mp="y7gjwpv5ngi3">
                      {row.cost}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </ScrollTable>
        </div>

        <div id="costo-title" className="mt-12 text-center" data-id="element-47" data-mp="1vnne6qrzsi49">
          <p className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-48" data-mp="1vp89iim4s536">
            El próximo entrenamiento puede ser diferente.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base italic text-gold sm:text-lg" data-id="element-49" data-mp="20k19d4ynek38">
            “El próximo entrenamiento puede ser el primero con un sistema real.”
          </p>
        </div>
      </div>
    </section>;
}